$.validator.addMethod("tcno", function(value) {
	var KimlikNo = value;
	if(KimlikNo == "___________" || KimlikNo == "")
		return true;
	if( ! KimlikNo.match(/^[0-9]{11}$/) )
		return false;

	pr1 = parseInt(KimlikNo.substr(0,1));
	pr2 = parseInt(KimlikNo.substr(1,1));
	pr3 = parseInt(KimlikNo.substr(2,1));
	pr4 = parseInt(KimlikNo.substr(3,1));
	pr5 = parseInt(KimlikNo.substr(4,1));
	pr6 = parseInt(KimlikNo.substr(5,1));
	pr7 = parseInt(KimlikNo.substr(6,1));
	pr8 = parseInt(KimlikNo.substr(7,1));
	pr9 = parseInt(KimlikNo.substr(8,1));
	pr10 = parseInt(KimlikNo.substr(9,1));
	pr11 = parseInt(KimlikNo.substr(10,1));
	
	if( (pr1+pr3+pr5+pr7+pr9+pr2+pr4+pr6+pr8+pr10) % 10 != pr11 )
		return false;
	if( ( (pr1+pr3+pr5+pr7+pr9)*7 + (pr2+pr4+pr6+pr8)*9 ) % 10 != pr10 )
		return false;
	if( ( (pr1+pr3+pr5+pr7+pr9)*8) % 10 != pr11 )
		return false;
	if(pr1==pr2 && pr1==pr3 && pr1==pr4 && pr1==pr5 && pr1==pr6 && pr1==pr7 && pr1==pr8 && pr1==pr9 && pr1==pr10 && pr11==0)
		return false;
	
	return true;
}, jQuery.validator.messages.tcno);

$.validator.addMethod("irsaNo", function(inp) {

	if(inp == "0000000000" ||
	    inp == "1111111111" ||
	    inp == "2222222222" ||
	    inp == "3333333333" ||
	    inp == "4444444444" ||
	    inp == "5555555555" ||
	    inp == "6666666666" ||
	    inp == "7777777777" ||
	    inp == "8888888888" ||
	    inp == "9999999999"){
		return false;
	}
	 
    var l = inp.length;
    if(l < 10 || parseInt(inp, 10) == 0){
    	return false;
    }
    
    inp = ('0000' + inp).substr(l + 4 - 10);
	if(parseInt(inp.substr(3, 6), 10) == 0){
		return false;
	}
	    
	var c = parseInt(inp.substr(9, 1), 10);
	    
	var s = 0;
    for (var i = 0; i < 9; i++) {
    	s += parseInt(inp.substr(i, 1), 10) * (10 - i);
    }
    s = s % 11;
    
    return (s < 2 && c == s) || (s >= 2 && c == (11 - s));
}, jQuery.validator.messages.irsano);

$.validator.addMethod("dateTr", function(value){
	if(value.length==0)
		return true;
	
	var date = null;
	try{
		date = $.datepicker.parseDate("dd.mm.yy",value.substr(0,10));
	}catch(e){
		return false;
	}
	return date!=null;
},jQuery.validator.messages.date);

$.validator.addMethod("doubleDateBoundries", function(thisDateStr, element, boundries) {
	if(thisDateStr.length==0)
		return true;
	
	var downBoundryDateStr = boundries.substring(0,10);
	var upBoundryDateStr = boundries.substring(11,21);
	
	try {
		var downBoundryDate = $.datepicker.parseDate("dd.mm.yy", downBoundryDateStr);
		var upBoundryDate = $.datepicker.parseDate("dd.mm.yy", upBoundryDateStr);
		var thisDate = $.datepicker.parseDate("dd.mm.yy", thisDateStr);
	} catch (e) {
		return false;
	}
	
	var thisTime = thisDate.getTime();
	
	if(thisTime < downBoundryDate.getTime()){		
//		jQuery.validator.messages.doubleDateBoundries = downBoundryDateStr + "'den sonraki bir tarih giriniz!";
		jQuery.validator.messages.doubleDateBoundries = getFmtMessagesWithArgs(FmtMessage.getMessage('js.date.after.warning'),downBoundryDateStr);
		return false;
	}else if (upBoundryDate.getTime() < thisTime){
//		jQuery.validator.messages.doubleDateBoundries = upBoundryDateStr + "'den önceki bir tarih giriniz!";
		jQuery.validator.messages.doubleDateBoundries = getFmtMessagesWithArgs(FmtMessage.getMessage('js.date.before.warning'),upBoundryDateStr);
		return false;
	}
	
	return true;
}, jQuery.validator.messages.doubleDateBoundries);


$.validator.addMethod("tripleDateBoundries", function(thisDateStr, element, boundries) {
	if(thisDateStr.length==0)
		return true;
	
	var downBoundryDateStr = boundries.substring(0,10);
	var upBoundryDateStr = boundries.substring(11,21);
	var bigOrLittleSign = boundries.substring(21,22); //< veya > isareti
	var otherInputId = boundries.substring(22);
	var otherDateStr =  $(otherInputId).val();
	
	try {
		var downBoundryDate = $.datepicker.parseDate("dd.mm.yy", downBoundryDateStr);
		var upBoundryDate = $.datepicker.parseDate("dd.mm.yy", upBoundryDateStr);
		var otherDate = $.datepicker.parseDate("dd.mm.yy", otherDateStr.substr(0,10));
		var thisDate = $.datepicker.parseDate("dd.mm.yy", thisDateStr.substr(0,10));
	} catch (e) {
		return false;
	}
	
	var thisTime = thisDate.getTime();
	
	if(thisTime <= downBoundryDate.getTime()){		
//		jQuery.validator.messages.tripleDateBoundries = downBoundryDateStr + "'den sonraki bir tarih giriniz!";
		jQuery.validator.messages.tripleDateBoundries = getFmtMessagesWithArgs(FmtMessage.getMessage('js.date.after.warning'),downBoundryDateStr);
		return false;
	}else if (upBoundryDate.getTime() < thisTime){
//		jQuery.validator.messages.tripleDateBoundries = upBoundryDateStr + "'den önceki bir tarih giriniz!";
		jQuery.validator.messages.tripleDateBoundries = getFmtMessagesWithArgs(FmtMessage.getMessage('js.date.before.warning'),upBoundryDateStr);
		return false;
	}else if (otherDate != null && bigOrLittleSign=="<" && thisTime > otherDate.getTime()){
//		jQuery.validator.messages.tripleDateBoundries = otherDateStr + "'den önceki bir tarih giriniz!";
		jQuery.validator.messages.tripleDateBoundries = getFmtMessagesWithArgs(FmtMessage.getMessage('js.date.before.warning'),otherDateStr);
		return false;
	}else if (otherDate != null && bigOrLittleSign==">" && thisTime < otherDate.getTime()){
//		jQuery.validator.messages.tripleDateBoundries = otherDateStr + "'den sonraki bir tarih giriniz!";
		jQuery.validator.messages.tripleDateBoundries = getFmtMessagesWithArgs(FmtMessage.getMessage('js.date.after.warning'),otherDateStr);
		return false;
	}
	
	return true;
}, jQuery.validator.messages.tripleDateBoundries);

$.validator.addMethod("gsm", function(value){
		if(value !=  null && value.length != 0){
			var gsmNumbers = value.trim().replace(/\D/g,'');
			var isTR = $(".gsm_code").val().includes("+90");
			if(gsmNumbers.length < 9 && isTR){
				return false;
			}
		} 
		return true;
	
}, jQuery.validator.messages.gsm);


$.validator.addMethod("cc_owner_name", function(value){
	if(value.length==0)
		return true;
	
	try{
		var names = value.trim().split(' ');
		if(names.length < 2){
			return false;
		}
	}catch(e){
		return false;
	}
	return true;
},jQuery.validator.messages.cc_owner_name);

$.validator.addMethod("latinChars", function(value){
    
	value = value.replace(/ /g, '');
	
    for (i = 0; i < value.length; i++) { 
	    var convertedKeyCode = value.charCodeAt(i);
	    if ((convertedKeyCode < 65 || convertedKeyCode > 90) && convertedKeyCode != 46) {
			return false;
		}
	}
    
	return true;
},jQuery.validator.messages.latinChars);

$.validator.addMethod("cvc_warn", function(value){
	if(value.length==0 || value == '___')
		return false;
	
	return true;
	
},jQuery.validator.messages.cvc_warn);


$.validator.addMethod("gender_warn", function(value, element){
	
	if(value ==  null || value.length==0)
		return false;
	
//	var elementVal = $('[name="'+element.name+'"]:checked').val();
//	
//	if(typeof elementVal == 'undefined' || elementVal.length==0)
//		return false;
	
	return true;
	
},jQuery.validator.messages.gender_warn);


$.validator.addMethod("passNo_warn", function(value){
	if(value.length==0 || value == '____________')
		return false;

	return true;
	
},jQuery.validator.messages.passNo_warn);



$.validator.addMethod("cc_expire_month_warn", function(value){
	
	if(value ==  null || value.length==0)
		return false;
	
	return true;
	
},jQuery.validator.messages.cc_expire_month_warn);


$.validator.addMethod("milesWarning", function(value, element, options){
	//BTOC-9793
	if(value.length > 0 && options == 'TK'){
		if(value.length != 9)
			return false;
	}
	return true;
},jQuery.validator.messages.milesWarning);


$.validator.addMethod("cc_expire_year_warn", function(value){
	
	if(value ==  null  || value.length==0)
		return false;
	
	return true;
	
},jQuery.validator.messages.cc_expire_year_warn);

$.validator.addMethod("doubleYearBoundries", function(thisYearStr, element, boundries) {
	if(thisYearStr.length==0)
		return true;

	try {
		
		var downBoundryYearStr = boundries.substring(0,4);
		var upBoundryYearStr = boundries.substring(5,9);
	
	} catch (e) {
		return false;
	}

	if(thisYearStr < downBoundryYearStr){		
//		jQuery.validator.messages.doubleDateBoundries = downBoundryDateStr + "'den sonraki bir tarih giriniz!";
		jQuery.validator.messages.doubleYearBoundries = getFmtMessagesWithArgs(FmtMessage.getMessage('js.date.after.warning'),downBoundryYearStr);
		return false;
	}else if (upBoundryYearStr < thisYearStr){
//		jQuery.validator.messages.doubleDateBoundries = upBoundryDateStr + "'den önceki bir tarih giriniz!";
		jQuery.validator.messages.doubleYearBoundries = getFmtMessagesWithArgs(FmtMessage.getMessage('js.date.before.warning'),upBoundryYearStr);
		return false;
	}
	
	return true;
}, jQuery.validator.messages.doubleYearBoundries);

$.validator.addMethod("doubleDayBoundries", function(thisDayStr, element, boundries) {
	if(thisDayStr.length==0)
		return true;

	try {
		
		var downBoundryDayStr = boundries.substring(0,1);
		var upBoundryDayStr = boundries.substring(2,4);
	
	} catch (e) {
		return false;
	}

	if(parseInt(thisDayStr) < parseInt(downBoundryDayStr)){		
//		jQuery.validator.messages.doubleDateBoundries = downBoundryDateStr + "'den sonraki bir tarih giriniz!";
		jQuery.validator.messages.doubleDayBoundries = getFmtMessagesWithArgs(FmtMessage.getMessage('js.date.after.warning'),downBoundryDayStr);
		return false;
	}else if (parseInt(upBoundryDayStr) < parseInt(thisDayStr)){
//		jQuery.validator.messages.doubleDateBoundries = upBoundryDateStr + "'den önceki bir tarih giriniz!";
		jQuery.validator.messages.doubleDayBoundries = getFmtMessagesWithArgs(FmtMessage.getMessage('js.date.before.warning'),upBoundryDayStr);
		return false;
	}
	
	return true;
}, jQuery.validator.messages.doubleDayBoundries);

$.validator.addMethod("doubleMonthBoundries", function(thisMonthStr, element, boundries) {
	if(thisMonthStr.length==0)
		return true;

	try {
		
		var downBoundryMonthStr = boundries.substring(0,1);
		var upBoundryMonthStr = boundries.substring(2,4);
	
	} catch (e) {
		return false;
	}

	if(parseInt(thisMonthStr) < parseInt(downBoundryMonthStr)){		
//		jQuery.validator.messages.doubleDateBoundries = downBoundryDateStr + "'den sonraki bir tarih giriniz!";
        jQuery.validator.messages.doubleMonthBoundries = getFmtMessagesWithArgs(FmtMessage.getMessage('js.date.after.warning'),downBoundryMonthStr);
		return false;
	}else if (parseInt(upBoundryMonthStr) < parseInt(thisMonthStr)){
//		jQuery.validator.messages.doubleDateBoundries = upBoundryDateStr + "'den önceki bir tarih giriniz!";
		jQuery.validator.messages.doubleMonthBoundries = getFmtMessagesWithArgs(FmtMessage.getMessage('js.date.before.warning'),upBoundryMonthStr);
		return false;
	}
	
	return true;
}, jQuery.validator.messages.doubleMonthBoundries);


$.validator.addMethod("taxno", function(value){

    if(value.match(/^[0-9]{10}$/)){
        return taxVNumberValidation(value);
    }
    else if(value.match(/^[0-9]{11}$/)){
        return identityNumberValidation(value);
    }

    return false;

},jQuery.validator.messages.taxno);


function taxVNumberValidation(text){
    var validationNum =  parseInt(text[text.length - 1]);
    var p = [];
    for (var i = 0; i < text.length - 1; i++) {
        var index = i + 1;
        var num = parseInt(text[i]);
        p[i] = (num + 10 - index) % 10;
        p[i] = p[i] == 9 ? p[i] : (p[i] * Math.pow(2, (10 - index))) % 9;
    }

    var generatedValidationNumber = null;
    var v1 = p.reduce(function (a, b) { return a + b });

    generatedValidationNumber = (10 - (v1 % 10)) % 10;
    return validationNum == generatedValidationNumber;
}

function identityNumberValidation(value) {
    var KimlikNo = value;
    pr1 = parseInt(KimlikNo.substr(0,1));
    pr2 = parseInt(KimlikNo.substr(1,1));
    pr3 = parseInt(KimlikNo.substr(2,1));
    pr4 = parseInt(KimlikNo.substr(3,1));
    pr5 = parseInt(KimlikNo.substr(4,1));
    pr6 = parseInt(KimlikNo.substr(5,1));
    pr7 = parseInt(KimlikNo.substr(6,1));
    pr8 = parseInt(KimlikNo.substr(7,1));
    pr9 = parseInt(KimlikNo.substr(8,1));
    pr10 = parseInt(KimlikNo.substr(9,1));
    pr11 = parseInt(KimlikNo.substr(10,1));

    if( (pr1+pr3+pr5+pr7+pr9+pr2+pr4+pr6+pr8+pr10) % 10 != pr11 )
        return false;
    if( ( (pr1+pr3+pr5+pr7+pr9)*7 + (pr2+pr4+pr6+pr8)*9 ) % 10 != pr10 )
        return false;
    if( ( (pr1+pr3+pr5+pr7+pr9)*8) % 10 != pr11 )
        return false;
    if(pr1==pr2 && pr1==pr3 && pr1==pr4 && pr1==pr5 && pr1==pr6 && pr1==pr7 && pr1==pr8 && pr1==pr9 && pr1==pr10 && pr11==0)
        return false;

    return true;
}

$.validator.addMethod("duplicatePassengerSurname", function(value, element){
	var rowName = $(element).parent().parent().find("[inputType=name]").val();

	var rowSurName = value;

	rowSurName = rowSurName.replace(' ', '');

	var result = true;

	if(rowName.length > 0 && rowSurName.length > 0){
		var sameCount = 0;
		$('[inputType="name"]').each(function(){
			var name = $(this).val();
			var surName = $(this).parent().parent().find("[inputType=surname]").val();
			surName = surName.replace(' ', '');

			if(name.length > 0 && surName.length > 0 && rowName == name && rowSurName == surName){
				sameCount ++;
				if(sameCount > 1){
					result = false;
				}
			}
		});
	}
	return result;

},jQuery.validator.messages.duplicatePassenger);

$.validator.addMethod("duplicatePassengerName", function(value, element){
	var rowName = value;

	var rowSurName = $(element).parent().parent().find("[inputType=surname]").val();

	rowSurName = rowSurName.replace(' ', '');

	var result = true;

	if(rowName.length > 0 && rowSurName.length > 0){
		var sameCount = 0;
		$('[inputType="name"]').each(function(){
			var name = $(this).val();
			var surName = $(this).parent().parent().find("[inputType=surname]").val();
			surName = surName.replace(' ', '');

			if(name.length > 0 && surName.length > 0 && rowName == name && rowSurName == surName){
				sameCount ++;
				if(sameCount > 1){
					result = false;
				}
			}
		});
	}
	return result;

},jQuery.validator.messages.duplicatePassenger);

$.validator.addMethod("hesCode", function(value){
	if(value.length==0 || value == null || value == '')
		return false;
	
	return true;
},jQuery.validator.messages.hesCode);